import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { FormationApi } from '@/api/formation';

const Mark = ({ ok }: { ok: boolean }) => (
  <span className={ok ? 'text-green-600' : 'text-muted-foreground'}>{ok ? '✓' : '—'}</span>
);

/** Avancement de chaque membre de l'équipe (gérant uniquement, contrôlé côté SQL). */
export function FormationTeamProgress() {
  const [open, setOpen] = useState(false);
  const { data } = useQuery({
    queryKey: ['formation-progress-team'],
    enabled: open,
    staleTime: 60_000,
    queryFn: async () => {
      const r = await FormationApi.getTeamProgress();
      return r.ok ? r.value : [];
    },
  });

  return (
    <div className="mt-3">
      <Button size="sm" variant="ghost" onClick={() => setOpen((o) => !o)}>
        {open ? 'Masquer l’équipe' : 'Voir l’avancement de l’équipe'}
      </Button>
      {open && (
        <table className="mt-2 w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-muted-foreground">
              <th className="py-1 font-medium">Membre</th>
              <th className="py-1 text-center font-medium">1re vente</th>
              <th className="py-1 text-center font-medium">Carte</th>
              <th className="py-1 text-center font-medium">Clôture Z</th>
            </tr>
          </thead>
          <tbody>
            {(data ?? []).map((m) => (
              <tr key={m.userId} className="border-t">
                <td className="py-1">{m.name}</td>
                <td className="py-1 text-center">
                  <Mark ok={m.premiereVente} />
                </td>
                <td className="py-1 text-center">
                  <Mark ok={m.venteCarte} />
                </td>
                <td className="py-1 text-center">
                  <Mark ok={m.clotureZ} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
